<template>
  <v-form v-model="form_validate_status" ref="form" :loading="loading">
    <v-card
      max-width="750"
      class="mx-auto"
      color="grey-lighten-3"
      :disabled="loading"
      :loading="loading"
    >
      <v-layout>
        <CustomAppBar :page="7" :title="$t('info_card.title_page7')" />
        <v-main
          ><v-card-text
            ><h2 class="pb-3">{{ $t("info_card.p7_title1") }}</h2>
            <p>
              {{ $t("info_card.p7_text1") }}
            </p></v-card-text
          ><v-divider></v-divider>
          <v-card-text>
            <h2 class="pb-3">{{ $t("info_card.p7_title2") }}</h2>
            <p class="pb-2">
              {{ $t("info_card.p7_text2") }}
            </p>
            <p>
              <v-icon icon="mdi-circle-medium"></v-icon>
              {{ $t("info_card.p7_text21") }}
            </p>
            <p>
              <v-icon icon="mdi-circle-medium"></v-icon>
              {{ $t("info_card.p7_text22") }}
            </p>
            <p>
              <v-icon icon="mdi-circle-medium"></v-icon>
              {{ $t("info_card.p7_text23") }}
            </p>
            <p>
              <v-icon icon="mdi-circle-medium"></v-icon>
              {{ $t("info_card.p7_text24") }}
            </p>
            <p>
              <v-icon icon="mdi-circle-medium"></v-icon>
              {{ $t("info_card.p7_text25") }}
            </p>
          </v-card-text>
          <v-divider></v-divider
          ><v-card-text>
            <v-checkbox
              v-model="checked"
              value="yes"
              :label="$t('info_card.p7_textAgree')"
              :color="checked === 'yes' ? 'success' : ''"
            ></v-checkbox></v-card-text
          ><v-divider></v-divider>
          <v-card-text
            ><div
              class="text-end mb-2 text-red"
              v-if="is_saved_before_page === false"
            >
              {{ $t("info.have_not_fill_page_before") }}
            </div>
            <div class="text-end">
              <v-btn color="primary" size="large" class="mr-2" to="/page6"
                >Back</v-btn
              >
              <v-btn
                color="primary"
                size="large"
                :disabled="is_saved_before_page === false"
                @click="saveData"
                >{{ is_lock_kmitl1 === true ? "Next" : "Save & Next" }}</v-btn
              >
            </div></v-card-text
          >
        </v-main>
      </v-layout>
    </v-card>
  </v-form>
</template>

<script>
import validator from "@/helper/validator";
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import PageProvider from "@/services/page.provider";
const pageService = new PageProvider();

export default {
  name: "PageSeven",

  components: {
    CustomAppBar,
  },
  data: () => ({
    form_validate_status: false,
    loading: false,
    is_lock_kmitl1: true,
    is_saved_before_page: false,

    checked: null,
    already_consent_before: false,
    confirm_date: null,

    requiredRules: [validator.required],
  }),
  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },
    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },
  },
  methods: {
    async getData() {
      this.loading = true;
      this.is_lock_kmitl1 =
        this.surrogated_student_info.LOCK_KMITL1 == "0" ? false : true;

      this.already_consent_before =
        this.surrogated_student_info.ENTERED.includes("7");

      const data = await pageService.getPage7(this.uid).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      this.confirm_date = data.CONFIRM_DATE;
      if (this.confirm_date) {
        this.checked = "yes";
      }
      this.loading = false;
    },
    async saveData() {
      if (this.form_validate_status === true) {
        if (this.is_lock_kmitl1 === false) {
          this.loading = true;

          const response = await pageService
            .setPage7({
              uid: this.uid,
              checked: this.checked ?? null,
            })
            .catch((error) => {
              this.$toast.error(JSON.stringify(error.response.data.message));
              this.loading = false;
            });
          if (response && response.status) {
            this.$toast.success(this.$t("toast.save_successfully"));
            this.$router.push("/page8");
          } else this.$toast.error(this.$t("toast.cannot_save"));
          this.loading = false;
        } else {
          this.$router.push("/page8");
        }
      } else {
        this.$toast.error(this.$t("toast.cannot_save"));
      }
    },
  },
  async created() {
    await this.$store.dispatch("user/getUserInfo");
    this.is_saved_before_page =
      this.surrogated_student_info.ENTERED.includes("6");
    if (this.is_saved_before_page === false) {
      this.$router.push("/main");
    }

    this.getData();
  },
};
</script>

<style scoped></style>
